import { Stack } from ".";

export const DigitalDesignItems: Stack[] = [
    {
        alt: 'figma',
        url: '/images/services/tools/digital-design/figma.webp',
    },
    {
        alt: 'adobe-xd',
        url: '/images/services/tools/digital-design/xd.webp',
    },
    {
        alt: 'adobe-ps',
        url: '/images/services/tools/digital-design/ps.webp',
    },
    {
        alt: 'adobe-ai',
        url: '/images/services/tools/digital-design/ai.webp',
    },
    {
        alt: 'adobe-pr',
        url: '/images/services/tools/digital-design/pr.webp',
    },
    {
        alt: 'adobe-ae',
        url: '/images/services/tools/digital-design/ae.webp',
    },
    {
        alt: 'invision',
        url: '/images/services/tools/digital-design/invision.webp',
    },
    {
        alt: 'sketch',
        url: '/images/services/tools/digital-design/sketch.webp',
    },
];

export const FrontendItems: Stack[] = [
    {
        alt: 'react',
        url: '/images/react.webp'
    },
    {
        alt: 'vuejs',
        url: '/images/logo-vuejs.webp'
    },
    {
        alt: 'angular',
        url: '/images/angulr.webp'
    },
    {
        alt: 'typescript',
        url: '/images/typescript.webp'
    },
    {
        alt: 'javascript',
        url: '/images/services/tools/frontend/js.webp'
    },
    {
        alt: 'html',
        url: '/images/services/tools/frontend/html.webp'
    },
    {
        alt: 'bootstrap',
        url: '/images/services/tools/frontend/bootstrap.webp'
    },
    {
        alt: 'css',
        url: '/images/services/tools/frontend/css.webp'
    },
    {
        alt: 'webpack',
        url: '/images/services/tools/frontend/webpack.webp'
    },
];

export const BackendItems: Stack[] = [
    {
        alt: 'nodejs',
        url: '/images/services/tools/backend/nodejs.webp'
    },
    {
        alt: 'java',
        url: '/images/services/tools/backend/java.webp'
    },
    {
        alt: '.net',
        url: '/images/services/tools/backend/dotnet.webp'
    },
    {
        alt: 'php',
        url: '/images/services/tools/backend/php.webp'
    },
    {
        alt: 'golang',
        url: '/images/services/tools/backend/golang.webp'
    },
    {
        alt: 'python',
        url: '/images/services/tools/backend/python.webp'
    },
    {
        alt: 'rust',
        url: '/images/services/tools/backend/rust.webp'
    },
    {
        alt: 'ruby',
        url: '/images/services/tools/backend/ruby.webp'
    },
];

export const MobileItems: Stack[] = [
    {
        alt: 'flutter',
        url: '/images/services/tools/mobile/flutter.webp'
    },
    {
        alt: 'react native',
        url: '/images/services/tools/mobile/react-native.webp'
    },
    {
        alt: 'kotlin',
        url: '/images/services/tools/mobile/kotlin.webp'
    },
    {
        alt: 'swift',
        url: '/images/services/tools/mobile/swift.webp'
    },
    {
        alt: 'java',
        url: '/images/services/tools/backend/java.webp'
    },
    {
        alt: 'ionic',
        url: '/images/services/tools/mobile/ionic.webp'
    },
    {
        alt: 'rust',
        url: '/images/services/tools/backend/rust.webp'
    },
    {
        alt: 'objc',
        url: '/images/services/tools/mobile/objc.webp'
    },
];

export const BlockchainItems: Stack[] = [
    {
        alt: 'near',
        url: '/images/logo-near.png'
    },
    {
        alt: 'polygon',
        url: '/images/polygon.webp'
    },
    {
        alt: 'cardano',
        url: '/images/logo-cardano.webp'
    },
    {
        alt: 'algorand',
        url: '/images/logo-igorand.png'
    },
    {
        alt: 'avalanche',
        url: '/images/avalanche.webp'
    },
    {
        alt: 'solidity',
        url: '/images/logo-solidity.png'
    },
    {
        alt: 'bitcoin',
        url: '/images/bitcoin-logo.webp'
    },
    {
        alt: 'ethereum',
        url: '/images/logo-ethereum.webp'
    },
    {
        alt: 'binance',
        url: '/images/binance.webp'
    },
    {
        alt: 'solana',
        url: '/images/solana-new.webp'
    },
];

export const InfrastructureItems: Stack[] = [
    {
        alt: 'sql-server',
        url: '/images/services/tools/infrastructure/sql-server.webp'
    },
    {
        alt: 'mongodb',
        url: '/images/services/tools/infrastructure/mongodb.webp'
    },
    {
        alt: 'mysql',
        url: '/images/services/tools/infrastructure/mysql.webp'
    },
    {
        alt: 'oracle',
        url: '/images/services/tools/infrastructure/oracle.webp'
    },
    {
        alt: 'postgresql',
        url: '/images/services/tools/infrastructure/postgresql.webp'
    },
    {
        alt: 'firebase',
        url: '/images/services/tools/infrastructure/firebase.webp'
    },
    {
        alt: 'aws',
        url: '/images/services/tools/infrastructure/amazonwebservices.webp'
    },
    {
        alt: 'google cloud',
        url: '/images/services/tools/infrastructure/google-cloud.webp'
    },
    {
        alt: 'azure',
        url: '/images/services/tools/infrastructure/azure.webp'
    },
];

export const TestingQAItems: Stack[] = [
    {
        alt: 'selenium',
        url: '/images/services/tools/testing-qa/selenium.webp'
    },
    {
        alt: 'jmeter',
        url: '/images/services/tools/testing-qa/jmeter.webp'
    },
    {
        alt: 'postman',
        url: '/images/services/tools/testing-qa/postman.webp'
    },
    {
        alt: 'redmine',
        url: '/images/services/tools/testing-qa/redmine.webp'
    },
    {
        alt: 'testrail',
        url: '/images/services/tools/testing-qa/testrail.webp'
    },
    {
        alt: 'swagger',
        url: '/images/services/tools/testing-qa/swagger.webp'
    },
    {
        alt: 'androidstudio',
        url: '/images/services/tools/testing-qa/androidstudio.webp'
    },
    {
        alt: 'vscode',
        url: '/images/services/tools/testing-qa/vscode.webp'
    },
    {
        alt: 'browserstack',
        url: '/images/services/tools/testing-qa/browserstack.webp'
    },
];

export const ReportAndCommunicationItems: Stack[] = [
    {
        alt: 'gmail',
        url: '/images/services/tools/report-communication/gmail.webp'
    },
    {
        alt: 'microsoft team',
        url: '/images/services/tools/report-communication/microsoft-team.webp'
    },
    {
        alt: 'slack',
        url: '/images/services/tools/report-communication/slack.webp'
    },
    {
        alt: 'telegram',
        url: '/images/services/tools/report-communication/telegram.webp'
    },
    {
        alt: 'zoom',
        url: '/images/services/tools/report-communication/zoom.webp'
    },
    {
        alt: 'jira',
        url: '/images/services/tools/report-communication/jira.webp'
    },
    {
        alt: 'asana',
        url: '/images/services/tools/report-communication/asana.webp'
    },
    {
        alt: 'mattermost',
        url: '/images/services/tools/report-communication/mattermost.webp'
    },

];


